exports.map = require('rxjs/internal/operators/map').map
